import { default as timeattendancelogsTypes } from "./types";

const {
  ADD_TIMEATTENDANCELOG_REQUEST,
  ADD_TIMEATTENDANCELOG_SUCCESS,
  ADD_TIMEATTENDANCELOG_FAILURE,
  FETCH_TIMEATTENDANCELOGS_REQUEST,
  FETCH_TIMEATTENDANCELOGS_SUCCESS,
  FETCH_TIMEATTENDANCELOGS_FAILURE,
} = timeattendancelogsTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TIMEATTENDANCELOG_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_TIMEATTENDANCELOG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_TIMEATTENDANCELOG_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_TIMEATTENDANCELOGS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_TIMEATTENDANCELOGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_TIMEATTENDANCELOGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
